module.exports = __webpack_public_path__ + "static/media/JSNKC3.15c6bf5a.png";